import { E_AppRoutes } from '@/types/Routes';
import { E_ActiveView } from '@/types/WidgetHeader';
import { FlexiblePointsRedemption } from '@/views/FlexiblePointsRedemption';
import { Login } from '@/views/Login';
import { PostRegistration } from '@/views/PostRegistration';
import { Redemption } from '@/views/Redemption';
import { RegisteredCustomer } from '@/views/RegisteredCustomer';
import { UnregisteredCustomer } from '@/views/UnregisteredCustomer';

export const ROUTE_COMPONENTS = {
  [E_AppRoutes.LOGIN]: <Login />,
  [E_AppRoutes.UNREGISTERED_CUSTOMER]: <UnregisteredCustomer />,
  [E_AppRoutes.POST_REGISTRATION]: <PostRegistration />,
  [E_AppRoutes.REGISTERED_CUSTOMER]: <RegisteredCustomer />,
  [E_AppRoutes.REDEMPTION]: <Redemption />,
  [E_AppRoutes.FLEXIBLE_POINTS]: <FlexiblePointsRedemption />,
};

export const ROUTE_VIEW_MAP: Record<E_AppRoutes, E_ActiveView> = {
  [E_AppRoutes.LOGIN]: E_ActiveView.MAIN,
  [E_AppRoutes.UNREGISTERED_CUSTOMER]: E_ActiveView.MAIN,
  [E_AppRoutes.POST_REGISTRATION]: E_ActiveView.POST_REGISTRATION,
  [E_AppRoutes.REGISTERED_CUSTOMER]: E_ActiveView.POST_REGISTRATION,
  [E_AppRoutes.REDEMPTION]: E_ActiveView.REDEMPTION,
  [E_AppRoutes.FLEXIBLE_POINTS]: E_ActiveView.FLEXIBLE_POINTS,
};
